import CssBaseline from '@mui/material/CssBaseline';
import type { ThemeProviderProps as MuiThemeProviderProps, Theme } from '@mui/material/styles';
import { ThemeProvider as ThemeVarsProvider } from '@mui/material/styles';
import { useMemo } from 'react';

import { AgentOrbitRingStyles } from '../components/button/AgentOrbitRing';
import { useSettingsContext } from '../components/settings/context/useSettingsContext';
import { createTheme } from './createTheme';
import type {} from './extendThemeTypes';
import type { ThemeOptions } from './types';

export type ThemeProviderProps = Omit<MuiThemeProviderProps, 'theme'> & {
  theme?: Theme;
  themeOverrides?: ThemeOptions;
};

export function ThemeProvider({ themeOverrides, children, ...other }: ThemeProviderProps) {
  const { colorScheme, direction } = useSettingsContext().state;

  // Only the colour scheme feeds the theme; rebuilding it on every settings change (a nav collapse, say) hands every
  // styled component a new theme object and restyles the whole page.
  const theme = useMemo(
    () => createTheme({ settingsState: { direction, colorScheme }, themeOverrides }),
    [direction, colorScheme, themeOverrides],
  );

  return (
    <ThemeVarsProvider disableTransitionOnChange theme={theme} {...other}>
      <CssBaseline />
      <AgentOrbitRingStyles />
      {children}
    </ThemeVarsProvider>
  );
}
